import { useSetRecoilState } from "recoil";
import WxContentsDispatcher from "./WxContentsDispatcher";
import { radarJmaInfoState } from "../../../store/RadarJmaInfoState";

const RadarDispatcher = (props) => {
  const setRadarJmaInfo = useSetRecoilState(radarJmaInfoState);

  props.contents.setJmaInfoDispatcher((jmaInfo) => {
    setRadarJmaInfo(jmaInfo);
  });

  return <WxContentsDispatcher {...props}/>
};

export default RadarDispatcher;